module.exports = __webpack_public_path__ + "static/media/image5-example.5cc61dab.jpg";